import { useEffect } from 'react';
import { useMap } from 'react-map-gl';
import { useSelector } from 'react-redux';
import { selectedAddressLocationSelector } from '../../store/selectors/general';

export const ZoomToCounty = ({ boundaryData, filterInfo }) => {
  const { current: map } = useMap();
  const { areaData } = boundaryData;
  const selectedAddressLocation = useSelector(selectedAddressLocationSelector);

  useEffect(() => {
    if (!map) return;

    if (selectedAddressLocation) {
      return;
    }

    if (areaData?.viewport && filterInfo.selectedCounty) {
      const { cen_lat, cen_lon, zoom } = areaData.viewport;
      map.easeTo({
        center: [cen_lon, cen_lat],
        zoom,
        duration: 1000,
      });
    } else if (!filterInfo.selectedCounty) {
      map.flyTo({
        center: [-99.254, 31.348],
        zoom: 6,
      });
    }
  }, [filterInfo.selectedCounty, map, areaData?.viewport, selectedAddressLocation]);

  return null;
};
